export default "__VITE_ASSET__B1tq947w__"